/* eslint-disable react/jsx-props-no-spreading */
import { Button, Form as BSForm, Spinner } from "react-bootstrap";
import { EnvelopeDashFill } from "react-bootstrap-icons";
import { Form as FinalForm, Field as FinalField } from "react-final-form";
import { validateForm } from "../_helpers";
import { sendPurchaseOrderItemMessageSchema } from "../_types";

export interface SendPurchaseOrderItemMessageFormProps {
  handleOnSubmit: (values: Record<string, any>) => void;
  serverError: string | string[] | undefined;
}

export function SendPurchaseOrderItemMessageForm({
  handleOnSubmit,
  serverError,
}: SendPurchaseOrderItemMessageFormProps) {
  return (
    <FinalForm
      initialValues={{ newMessageContent: "" }}
      onSubmit={handleOnSubmit}
      validate={(values: Record<string, any>) =>
        validateForm(values, sendPurchaseOrderItemMessageSchema)
      }
      render={({ form, handleSubmit, submitting, pristine }) => (
        <BSForm onSubmit={(values) => handleSubmit(values)?.then(form.reset)}>
          <FinalField
            name="messageContent"
            render={({ input, meta }) => (
              <BSForm.Group className="mb-3" controlId="sendMessageForm">
                <BSForm.Label>Send message:</BSForm.Label>
                <BSForm.Control
                  as="textarea"
                  placeholder="Enter your message here..."
                  {...input}
                  isInvalid={meta.error || serverError}
                />
                {((meta.touched && meta.error) || serverError) && (
                  <BSForm.Control.Feedback type="invalid">
                    {meta.error ?? serverError}
                  </BSForm.Control.Feedback>
                )}
              </BSForm.Group>
            )}
          />
          <Button
            size="sm"
            variant="secondary"
            type="button"
            onClick={() => form.reset()}
            disabled={submitting || pristine}
          >
            Clear
          </Button>{" "}
          <Button
            size="sm"
            variant="primary"
            type="submit"
            disabled={submitting || pristine}
          >
            {submitting ? (
              <Spinner as="span" size="sm" role="status" aria-hidden="true" />
            ) : (
              <EnvelopeDashFill />
            )}
            {" Send"}
          </Button>
        </BSForm>
      )}
    />
  );
}
